import React, { useState } from 'react';

import { CnReport, ReportFormData } from './types';
import { tooltipAddNewReportYear } from '../ReportsBeta/NewReport/NewReportContent';

type ReportFormProps = {
  initialData: Partial<CnReport> | null;
  onSubmit: (data: ReportFormData) => void;
  onCancel?: () => void;
  submitLabel?: string;
  isLoading?: boolean;
};

export default function ReportForm({
  initialData,
  onSubmit,
  onCancel,
  submitLabel = 'Save',
  isLoading = false,
}: ReportFormProps) {
  const currentYear = new Date().getFullYear();
  const yearOptions = [
    currentYear,
    currentYear - 1,
    currentYear - 2,
    currentYear - 3,
    currentYear - 4,
  ];

  const [formData, setFormData] = useState<ReportFormData>({
    name: initialData?.name || '',
    year: initialData?.year || yearOptions[0],
    start_date: initialData?.start_date || '',
    end_date: initialData?.end_date || '',
  });

  const [dateError, setDateError] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (formData.start_date && formData.end_date) {
      const startDate = new Date(formData.start_date);
      const endDate = new Date(formData.end_date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (endDate > today) {
        setDateError('End date cannot be in the future');
        return;
      }

      if (startDate >= endDate) {
        setDateError('Start date must be before end date');
        return;
      }
    }

    setDateError('');
    if (formData.name.trim() && !isLoading) {
      onSubmit(formData);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="cn-form-group">
        <label className="cn-form-label">
          What’s the name of the program you want to report on?
        </label>
        <label className="cn-form-label-description">
          The section is based on a single program your nonprofit operates. The
          program name you provide will appear on your Charity Navigator rating
          page. Choose the program that best reflects your monitoring and
          evaluation practices. This should not be an organization-level report.
        </label>
        <input
          type="text"
          value={formData.name}
          onChange={e => setFormData({ ...formData, name: e.target.value })}
          placeholder="Enter program name"
          maxLength={255}
          required
          className="cn-form-input"
        />
      </div>

      <div className="cn-form-group">
        <label className="cn-form-label">
          What’s the program year you want to report on?
        </label>
        <label className="cn-form-label-description">
          {tooltipAddNewReportYear}
        </label>
        <select
          value={formData.year}
          onChange={e =>
            setFormData({ ...formData, year: parseInt(e.target.value) })
          }
          className="cn-form-select"
        >
          {yearOptions.map(year => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

      {/*<div className="cn-form-group">
        <label className="cn-form-label">Start Date</label>
        <input
          type="date"
          value={formData.start_date}
          onChange={e =>
            setFormData({ ...formData, start_date: e.target.value })
          }
          className="cn-form-input"
        />
      </div>*/}

      {/*<div className="cn-form-group">
        <label className="cn-form-label">End Date</label>
        <input
          type="date"
          value={formData.end_date}
          onChange={e => setFormData({ ...formData, end_date: e.target.value })}
          max={new Date().toISOString().split('T')[0]}
          className="cn-form-input"
        />
      </div>*/}

      {dateError && <div className="cn-form-error">{dateError}</div>}

      <div className="cn-form-actions">
        <button
          type="submit"
          disabled={isLoading}
          className="cn-continue-button"
        >
          {isLoading && <div className="cn-spinner" />}
          {submitLabel}
        </button>
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            disabled={isLoading}
            className="cn-continue-button"
          >
            Cancel
          </button>
        )}
      </div>
    </form>
  );
}
